import classNames from 'classnames';
import React from 'react';

import { EOLCompleted } from '../assets/images';
import { Button } from './Button';
import { Icon } from './Icon';

export type UnitListItemStatusType = 'video' | 'done' | 'current' | 'blocked';

export interface UnitListItemProps {
  status: UnitListItemStatusType;
  title: string | JSX.Element;
  imgSrc?: string;
  buttonText?: string;
  buttonHref?: string;
  isEOL?: boolean;
  onClick?: () => void;
}

export const UnitListItem: React.FC<UnitListItemProps> = ({
  status,
  title,
  imgSrc,
  buttonText,
  buttonHref,
  isEOL,
  onClick,
}) => {
  const LessonListItemButton = () => {
    if (status === 'video') {
      return <Icon name="circle-play" />;
    } else if (status === 'done') {
      if (isEOL) {
        return <EOLCompleted />;
      }
      return <Icon name="chevron-right" />;
    } else if (status === 'current') {
      return (
        <Button
          label={buttonText || ''}
          href={buttonHref}
          onClick={onClick}
          variant="primary"
          size="sm"
        />
      );
    }
    return <></>;
  };

  const onListItemClick = () => {
    if (status === 'blocked' || !buttonHref) {
      return;
    }
    window.location.href = buttonHref;
  };

  const LessonListItemThumbnail = () => {
    if (status === 'video') {
      return (
        <div className="oe-lesson-list-item-thumbnail-image-wrapper">
          <img src={imgSrc} alt="Thumbnail" />
        </div>
      );
    } else if (status === 'done') {
      return (
        <div className="oe-lesson-list-item-thumbnail-icon-wrapper">
          <Icon name="check" />
        </div>
      );
    } else if (status === 'current') {
      return (
        <div className="oe-lesson-list-item-thumbnail-icon-wrapper">
          <Icon name="current" />
        </div>
      );
    }
    return (
      <div className="oe-lesson-list-item-thumbnail-icon-wrapper">
        <Icon name="lock" />
      </div>
    );
  };

  return (
    <div
      className={classNames('oe-lesson-list-item', `oe-lesson-list-item-${status}`)}
      onClick={onClick || onListItemClick}
    >
      <div className="oe-lesson-list-item-thumbnail">
        <LessonListItemThumbnail />
      </div>
      <div className="oe-lesson-list-item-title">{title}</div>
      <div className="oe-lesson-list-item-button-wrapper">
        <LessonListItemButton />
      </div>
    </div>
  );
};
